import type {CreateRoleFormPayload} from "./create-role.schema";
import {createAccessAdministrationRole} from "@project/sdk/access-administration";
import {CreateAccessAdministrationRoleResponse} from "@project/sdk/access-administration/zod";
import {mutationOptions} from "@tanstack/react-query";
import {accessAdministrationMutationKeys, roleKeys} from "../../access-administration-keys";

export function createRoleMutationOptions() {
  return mutationOptions({
    mutationKey: accessAdministrationMutationKeys.createRole,
    mutationFn: async (payload: CreateRoleFormPayload) =>
      CreateAccessAdministrationRoleResponse.parse(await createAccessAdministrationRole(payload)),
    onSuccess: async (_data, _variables, _context, {client}) => {
      await client.invalidateQueries({queryKey: roleKeys.lists()});
    },
  });
}
